import { Plugins } from '@leverege/plugin';
import Rsrc from "./Rsrc.js";
function install(plg = Plugins) {
  plg.addPlugin('Model', Rsrc);
}
export default {
  install
};